<template>
  <div v-if="userCopy" class="settings-member-item v-centerer generic-border">
    <div class="v-centerer">
      <UserThumbnail
        ref="thumbnail"
        :value="userCopy.id"
        :all-users="allUsers"
        disabled
        fetch-data
        edit-picture-on-click
      />
      <EditableLabel
        v-model="userCopy.firstName"
        :legend="$t('message.FIRST_NAME')"
        class="settings-member-item__label"
        use-textarea
        @input="save('firstName')"
      />
      <EditableLabel
        v-model="userCopy.lastName"
        :legend="$t('message.LAST_NAME')"
        class="settings-member-item__label"
        use-textarea
        @input="save('lastName')"
      />
    </div>
    <button
      v-if="!user.eraseRequest"
      class="generic-border generic-border--text-btn generic-border--red settings-member-item__delete"
      @click="onClickDelete"
    >
      <Icon>{{ deleteMedium }}</Icon>
      <span v-if="!$store.state.device.isSmartphonePortrait">{{ $t('message.DELETE') }}</span>
    </button>

    <div v-else class="field-hint erase-warning">
      {{ $t('message.USER_DATA_REMOVAL_DATE', { date: $moment(user.eraseRequest).format($t('minDateFormat')) }) }}
    </div>
  </div>
</template>

<script>
import toastr from 'toastr';
import { cloneDeep } from 'lodash';
// Vuex
import { EDIT_USER, FETCH_USERS } from '@/store/action-types';
// Components
import EditableLabel from '@/components/editable-label.vue';
import Icon from '@/components/icon.vue';
import UserThumbnail from '@/components/user-thumbnail.vue';
// Utils
import { calert, preventPastingStyles } from '@/utils/main';
import { deleteMedium } from '@/assets/icons';


export default {
  name: 'SettingsMemberItem',

  components: {
    EditableLabel,
    Icon,
    UserThumbnail,
  },

  props: {
    allUsers: {
      type: Array,
      default: () => [],
    },
    disabled: Boolean,
    user: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      deleteMedium,
      userCopy: null,
    };
  },

  watch: {
    user() {
      this.userCopy = cloneDeep(this.user);
    },
  },

  created() {
    this.userCopy = cloneDeep(this.user);
  },

  methods: {
    save(param) {
      this.$store.dispatch(EDIT_USER, { id: this.userCopy.id, [param]: this.userCopy[param] });
    },
    setEraseRequest() {
      this.App.post(
        '/server/users/setEraseRequest.php',
        { id: this.user.id },
        (data) => {
          if (!(data instanceof Object)) {
            toastr.error(this.$t('message.CONNECTION_ERROR'));
            return;
          }
          toastr.success(this.$t('message.SAVED'));
          // Refresh user list
          this.$store.dispatch(FETCH_USERS).then(() => {
            this.$nextTick(preventPastingStyles);
          });
        },
      );
    },
    onClickDelete() {
      calert(this.$t('message.CONFIRM_USER_DATA_REMOVAL_REQUEST'), [
        {
          title: this.$t('message.SEND'),
          sClass: 'red',
          action: this.setEraseRequest,
        },
        {
          title: this.$t('message.CANCEL'),
        },
      ]);
    },
  },
};
</script>

<style lang="scss">
@import '@/assets/scss/vars.scss';

.settings-member-item {
  margin-top: 0.7rem;
  padding: $page-content-padding;
  justify-content: space-between;

  &__label {
    flex: 1;
    min-width: 0px;
    margin-left: 1.5rem;
    max-width: 15rem;
  }
  .user-thumbnail {
    flex: 0 0 auto;
    margin-right: 10px;
    pointer-events: auto; // Overwrite -.user-thumbnail--disabled behavior

    &__avatar {
      width: 2.5rem;
      height: 2.5rem;

      &--initials {
        font-size: 1.1em;
      }
    }
  }

  &__delete {
    margin-left: .5rem;
  }
}

@media (max-width: $smartphone-portrait) {
  .settings-member-item {
    &__delete {
      .icon {
        margin-right: 0px;
      }
    }
  }
}
</style>
